import juice from 'juice';
import React, { useMemo } from 'react';

import { render } from '@react-email/render';
import { TTemplate } from '@wp-block-builder/package';
import ReadOnlyMessage from '@wp-block-builder/views/ReadOnlyMessage';

import { WpRendererError } from '@waypoint/templates';

type Props = {
  configuration: TTemplate;
  variables: Record<string, unknown>;
};

type State = {
  currentLiquidError: null | WpRendererError;
};
export default class ThumbnailWaypointDocument extends React.Component<Props, State> {
  static getDerivedStateFromError(error: unknown) {
    if (error instanceof WpRendererError) {
      return { currentLiquidError: error };
    }
    throw error;
  }

  constructor(props: Props) {
    super(props);
    this.state = { currentLiquidError: null };
  }

  render() {
    if (this.state.currentLiquidError) {
      return <p>There were errors rendering this template preview.</p>;
    }
    const { configuration, variables } = this.props;
    return <ThumbnailIframe configuration={configuration} variables={variables} />;
  }
}

function ThumbnailIframe({ configuration, variables }: Props) {
  const htmlString = useMemo(() => {
    const doc = (
      <ReadOnlyMessage footerBody={null} configuration={configuration} variables={variables} skipLiquid={false} />
    );

    return juice(render(doc, { pretty: true }), { decodeStyleAttributes: true });
  }, [configuration, variables]);

  return (
    <iframe title="Thumbnail Preview" srcDoc={htmlString} style={{ width: '100%', height: '100%', border: 'none' }} />
  );
}
